export default "__VITE_PUBLIC_ASSET__548042a3__"